
module.service("RosterReport", function(Report, $state) {

    Report.makeChildClass(RosterReport);
    RosterReport.prototype.$isList = true;

    function RosterReport(program, type, search, status) {
        var url = ['program', program.id, type];
        this._search = search;
        this._status = status;
        Report.call(this, url);
    }

    RosterReport.prototype.$sorterConfig = {
        default: 'name',
        direction: 'asc',
        columns: ['name', 'enrollment', 'issues', 'edited'],
    };

    Report.addExtraParameter(RosterReport, 'status', cb);
    Report.addExtraParameter(RosterReport, 'search', cb);

    function cb(name, value) {
        params = {page: 1};
        params[name] = value;
        $state.go('.', params, {location: 'replace'});
    }

    return RosterReport;
});


module.config(function($stateProvider, TagUrl) {

    var studentIndexUrl = new TagUrl()
        .addTagType('participant')
        .removeTag('status')
        .addSorterParams('name', 'asc')
        .addExtraParam('status', 'all')
        .addExtraParam('search', '')
        .addExtraParam('noRestore', {type: 'bool', value: false, squash: true}, false)
        .addPagerParams()

    $stateProvider.state('students', {
        parent: 'program',
        url: studentIndexUrl.buildUrl('/students'),
        params: studentIndexUrl.params,
        reloadOnSearch: false,
        permission: 'viewStudents',
        data: {tagUrl: studentIndexUrl, indexType: 'students'},
        templateUrl: 'students/overview/index',
        controller: 'StudentIndexController',
    });

    $stateProvider.state('participants', {
        parent: 'program',
        url: studentIndexUrl.buildUrl('/participants'),
        params: studentIndexUrl.params,
        reloadOnSearch: false,
        data: {tagUrl: studentIndexUrl, indexType: 'members'},
        templateUrl: 'students/overview/participants',
        controller: 'StudentIndexController',
        resolve: {
            auth: function(program, $checkPermissions, permissions) {
                if (program.ever_amc) {
                    return $checkPermissions('viewStudents', permissions);
                }
                return $checkPermissions('administerStudents', permissions);
            },
        },
    });
});

module.cC({
    name: 'StudentIndexController',
    inject: ['$scope', 'program', 'Notifications', 'ModelService',
             '$state', '$stateParams', 'RosterReport'],

    init: function() {
        var type = this.$state.current.data.indexType;

        this.report = new this.RosterReport(this.program, type,
                                            this.$stateParams.search,
                                            this.$stateParams.status);
        this.tagParams = {};
        this.$.tags = this.tags = [];

        this.$.report = this.report;
        this.$.sortOptions = sortOptions;

        this.$.pills = [
            {name: 'All', value: "all"},
            {name: 'With Issues', value: 'issues'}]

        if (type === 'students') {
            this.$.pills = this.$.pills.concat(
                {name: 'Active', value: "active"},
                {name: 'In Followup', value: "followup"},
                {name: 'Inactive', value: "inactive"});
        }
    },

    listen: {
        participant: {
            create: '_created',
        }
    },

    methods: {

        refresh: function(params) {
            this.tagParams = params || {};
            this.report.update(params)
        },

        addTag: function(tag) {
            this.$.tagFilter.addTag(tag);
        },

        _created: function(id) {
            var Notifications = this.Notifications;
            this.report.refresh();
            this.ModelService.debouncedGet('participant', id)
                .then(function(student) {
                    var msg = student.student_name + " was added successfully";
                    Notifications.success(msg);
                })
        },

        searchTags: function(student, query) {
            var params = {search: query};
            return this.ModelService
                .getModelRelation(student, 'tags/addable', params);
        },

        createTag: function(student, tag) {
            var set = tag.slug || 'tag';
            return this.ModelService.tagModel(student, set, tag.name);
        },

        removeTag: function(student, tag) {
            var set = tag.slug || 'tag';
            return this.ModelService.untagModel(student, set, tag.name);
        },
    }
});

var sortOptions = [
    {
        name: 'name',
        label: 'Name',
    },
    {
        name: 'enrollment',
        label: 'Enrollment Date',
        desc: true,
    },
    {
        name: 'edited',
        label: 'Last Updated',
        desc: true,
    },
    {
        name: 'issues',
        label: 'Issue Count',
        desc: 'true',
    },
];
